import { render } from "./GlobalTransactionDedipassView.vue?vue&type=template&id=3a2a90f2"
import script from "./GlobalTransactionDedipassView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionDedipassView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__